(ns common.schema.i18n)

;; Define which locales are allowed globally
(def ^:const allowed-locales #{:en :fi :sv})

;; ---------- Builders ----------

(defn translations-open
  "Open map: requires `required-locales` keys to be present and allows ANY subset
   of `allowed-locales` for the rest (no unknown locales beyond `allowed-locales`)."
  [required-locales]
  (let [required-locales (set required-locales)
        allowed? (fn [k] (contains? allowed-locales k))]
    [:and
     ;; 1) Enforce required keys with string values
     (into [:map]
           (for [loc required-locales]
             [loc string?]))
     ;; 2) Allow only allowed locales as keys; values must be strings
     [:map-of
      [:fn {:error/fn (fn [_ {:keys [value]}]
                        (str "unsupported locale key: " value))}
       allowed?]
      string?]]))

(defn translations-closed
  "Closed map: only keys in `required-locales ∪ optional-locales` are allowed.
   Required keys must be present; optional keys may be omitted."
  [required-locales optional-locales]
  (let [required-locales (set required-locales)
        optional-locales (set optional-locales)]
    (into [:map {:closed true}]
          (concat
           (for [loc required-locales] [loc string?])
           (for [loc optional-locales] [loc [:maybe string?]])))))                                  ; make optional via [:maybe ...]

;; ---------- Ready-made aliases ----------

(def Translations-en-open
  "Require :en; allow any subset of allowed-locales thereafter."
  (translations-open #{:en}))

(def Translations-en+fi-open
  "Require :en and :fi; allow any subset of allowed-locales thereafter."
  (translations-open #{:en :fi}))

(def Translations-en-closed
  "Require :en; only allow :en, :fi, :sv keys (with :fi and :sv optional)."
  (translations-closed #{:en} (disj allowed-locales :en)))

(def Translations-en+fi-closed
  "Require :en and :fi; only allow :en, :fi, :sv keys (with :sv optional)."
  (translations-closed #{:en :fi} (disj allowed-locales :en :fi)))
